/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * Helper: logout.
 */

import UserService from '../services/UserService';
import { logger } from './logger';
import { clearSessionId, getSessionId, stopHeartbeat } from './sessionManager';

/**
 * End the session on both sides: free the device slot on the API, then close the Auth0 session.
 *
 * Releasing first means the slot is available immediately instead of waiting for the idle window,
 * so a user signing out on one machine can sign straight back in on another.
 */
export async function releaseAndLogout(logout, returnTo = window.location.origin) {
  const sessionId = getSessionId();
  stopHeartbeat();

  if (sessionId) {
    try {
      await UserService.releaseSession(sessionId);
    } catch (error) {
      // Best effort. The slot still frees on the next login or when the idle window lapses.
      logger.warn('Could not release device session:', error);
    }
    clearSessionId();
  }

  logout({ logoutParams: { returnTo } });
}
